import React, { createContext } from 'react';

// Drag and Drop Context Provider
type DragAndDropOptionsContextType = {
	enabled: boolean;
};

export const DragAndDropOptionsContext = createContext<DragAndDropOptionsContextType>({
	enabled: false,
});

// Drag and Drop Provider Component
export type DragAndDropOptionsProviderProps = {
	children: React.ReactNode;
	enabled?: boolean;
};
export const DragAndDropOptionsProvider = ({
	children,
	enabled = false,
}: DragAndDropOptionsProviderProps) => {
	return (
		<DragAndDropOptionsContext.Provider value={{ enabled }}>
			{children}
		</DragAndDropOptionsContext.Provider>
	);
};
